<template>
	<div>
		<common-tab :list="tabList"></common-tab>
		<div id="information">
			<van-pull-refresh v-model="isRefresh" @refresh="onRefresh">
				<van-list v-model="isLoading" :finished="isFinished" finished-text="没有更多了">
					<div v-for="item in list" :key="item.id" @click="toDetail(item)">
						<div class="item">
							<div class="normal">
								<van-row type="flex" justify="space-between">
									<div class="word-container">
										<div class="title van-multi-ellipsis--l2">{{ item.title }}</div>
										<van-row class="remark" type="flex" justify="space-between">
											<div class="interaction">
												<span>阅读{{ item.read }}</span
												>&nbsp; <span class="comment">评论{{ item.comment }}</span
												>&nbsp;
												<span class="comment">点赞{{ item.like }}</span>
											</div>
											<div class="submit">{{ item.submit }}</div>
										</van-row>
									</div>
									<van-image width="100" height="70" v-if="item.img !== undefined" fit="cover" :src="item.img" lazy-load />
								</van-row>
							</div>
						</div>
						<van-divider class="divider" />
					</div>
				</van-list>
			</van-pull-refresh>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import CommonTab from '@/components/CommonTab.vue'
export default {
	components: {
		commonTab: CommonTab,
	},
	data() {
		return {
			list: [],
			pageNo: 1,
			pageSize: 20,
			isRefresh: false,
			isLoading: false,
			isFinished: false,
			tabId: '',
			tabList: [],
			firstTabId: '',
		}
	},
	watch: {
		communityId() {
			this.getTabList()
		},
		tabList() {
			this.onLoad()
		},
		tabId(value) {
			if (value.length > 0) {
				this.onLoad()
			}
		},
	},
	computed: {
		...mapGetters(['token', 'userId']),
	},

	methods: {
		onRefresh() {
			this.list = []
			this.pageNo = 1
			this.onLoad()
			this.$toast('刷新成功')
			this.isRefresh = false
		},
		// 时间戳
		formatDate(value) {
			let nowTime = new Date().getTime()

			let compareTime = nowTime - value
			let interval = compareTime / 1000
			console.log('时间差', interval)
			if (interval < 0) {
				return '刚刚'
			} else if (interval > 24 * 3600) {
				return Math.round(interval / 24 / 3600) + '天前'
			} else if (interval > 3600) {
				return Math.round(interval / 3600) + '小时前'
			} else if (interval > 60) {
				return Math.round(interval / 60) + '分钟前'
			} else {
				return '刚刚'
			}
		},

		onLoad() {
			let industryId = this.tabId
			if (this.tabId == '') {
				industryId = this.firstTabId
			}
			this.list = []
			this.vaxios.get(
				this.vaxios.host + '/open/api/v1/news/community/' + this.communityId,
				{
					paeNo: this.pageNo,
					pageSize: this.pageSize,
					type: 1,
					industryId: industryId,
				},
				(res) => {
					let item
					let array = res.data.list
					for (let i = 0; i < array.length; i++) {
						item = {
							id: array[i].id,
							img: array[i].thumbnail_url,
							title: array[i].name,
							read: array[i].read_count,
							comment: array[i].comment_count,
							like: array[i].likes_count,
							submit: array[i].publish_time,
						}
						item.submit = this.formatDate(array[i].publish_time)

						this.list.push(item)
					}
					console.log('资讯', res)

					// 加载状态结束
					this.pageNo++
					this.isLoading = false

					// 数据全部加载完成
					if (this.list.length >= res.data.total) {
						this.isFinished = true
					}
				},
				function(err) {
					console.log(err)
				}
			)
		},
		getTabList() {
			this.vaxios.get(
				`${this.vaxios.host}/open/api/v1/industries`,
				{
					communityId: this.communityId, //1,
					type: 1,
				},
				(res) => {
					if (res === -1 || !res.data || res.data.length === 0) return
					this.tabList = []
					this.firstTabId = res.data[0].id
					for (let i = 0; i < res.data.length; i++) {
						this.tabList.push({
							name: res.data[i].id,
							title: res.data[i].name,
						})
					}
				},
				function(err) {
					console.log(err)
				}
			)
		},
		toDetail(item) {
			let self = this
			self.$router.push({
				path: '/information/detail',
				query: {
					id: item.id,
					communityId: self.communityId,
				},
			})
		},
	},
	created() {
		this.communityId = this.$route.query.communityId
		this.getTabList()
	},
}
</script>

<style>
#hotspot {
	padding: 1rem;
}

.header {
	display: block;
	position: relative;
	height: 11.84375rem;
	margin-bottom: 0.65625rem;
}

.header .van-image {
	height: 11.84375rem;
}

.header .title {
	position: absolute;
	bottom: 2.125rem;
	left: 1rem;
	right: 1rem;
	font-size: 1rem;
	color: #ffffff;
}

.word-container {
	width: 100%;
}

.normal {
	padding: 1rem;
}

.normal .title {
	color: #272727;
	font-size: 1rem;
	margin-bottom: 33px;
}

.remark {
	color: #8d8d8d;
	font-size: 0.75rem;
}

.interaction {
}

.comment {
	margin-left: 1em;
}

.divider {
	margin: 0;
}

.submit {
	text-align: right;
	padding-right: 5px;
}

.comment {
	margin-left: 1em;
}
</style>
